module.exports = __webpack_public_path__ + "static/media/service21.bd323372.jpg";